mutation UploadAvatar($input: UploadAvatarInput!) {
  file: uploadAvatar(input: $input) {
    id
    url
  }
}
